import Vue from "vue";
import App from "./App";
import { router } from "./router";

import {
	Form,
	Button,
	Field,
	Image as VanImage,
	Row,
	Popup,
	NavBar,
	Picker,
	Area,
	Tabbar,
	TabbarItem,
	Search,
	Tag,
	Col,
	Icon,
	Cell,
	CellGroup,
	Swipe,
	Toast,
	SwipeItem,
	GoodsAction,
	GoodsActionIcon,
	GoodsActionButton,
	Rate,
} from "vant";

Vue.use([
	Form,
	Button,
	Field,
	VanImage,
	Row,
	NavBar,
	Picker,
	Popup,
	Area,
	Tabbar,
	TabbarItem,
	Search,
	Tag,
	Col,
	Icon,
	Cell,
	CellGroup,
	Swipe,
	Toast,
	SwipeItem,
	GoodsAction,
	GoodsActionIcon,
	GoodsActionButton,
	Rate,
]);

new Vue({
	router,
	el: "#app",
	render: (h) => h(App),
});
